import { memo } from "react";

import { hyphenate } from "neetocist";
import { Typography } from "neetoui";

import HelpPopover from "components/HelpPopover";

import TimeItem from "./TimeItem";

const MetricItem = ({ metric, value, helpText, isTime, isPercentage }) => {
  const renderTime = value => {
    const { h: hours, m: minutes, s: seconds } = value;
    const showSeconds = !hours && !minutes;

    return (
      <div className="flex gap-2">
        {!!hours && <TimeItem suffix="H" value={hours} />}
        {!!minutes && <TimeItem suffix="M" value={minutes} />}
        {(!!seconds || showSeconds) && <TimeItem suffix="S" value={seconds} />}
      </div>
    );
  };

  return (
    <div
      className="nf-insights__metric-item neeto-ui-border-gray-200 border-b pb-4"
      data-testid={`${hyphenate(metric)}-metric`}
    >
      <div className="flex items-center gap-2">
        <div className="flex items-end gap-x-1">
          {isTime ? (
            renderTime(value)
          ) : (
            <Typography
              className="neeto-ui-text-gray-800"
              data-testid="insights-count"
              style="h1"
              weight="semibold"
            >
              {value || 0}
              {isPercentage ? "%" : ""}
            </Typography>
          )}
        </div>
        {helpText && (
          <div>
            <HelpPopover description={helpText} />
          </div>
        )}
      </div>
      <Typography
        className="neeto-ui-text-gray-700"
        data-testid="insights-type"
        style="body3"
      >
        {metric}
      </Typography>
    </div>
  );
};

export default memo(MetricItem);
